export function AdminPageLayout({ children, className = "" }) {
  return (
    <div className={`container mx-auto px-4 py-6 ${className}`}>{children}</div>
  );
}

export function AdminPageHeader({ title, subtitle, actions, className = "" }) {
  return (
    <div
      className={`mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between ${className}`}
    >
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-gray-900">{title}</h1>
        {subtitle ? <p className="mt-1 text-sm text-gray-500">{subtitle}</p> : null}
      </div>
      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}

export function AdminPageCard({ children, className = "" }) {
  return (
    <div
      className={`overflow-hidden rounded-xl border border-gray-200/60 bg-white shadow-sm ${className}`}
    >
      {children}
    </div>
  );
}

export function AdminPageCardHeader({ title, children, actions, className = "" }) {
  return (
    <div
      className={`flex items-center justify-between border-b border-gray-100 p-4 ${className}`}
    >
      {title ? <div className="text-sm font-semibold text-gray-900">{title}</div> : children}
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}

export function AdminPageCardToolbar({ children, className = "" }) {
  return (
    <div
      className={`border-b border-gray-100 bg-slate-50/50 px-4 py-4 sm:px-5 ${className}`}
    >
      {children}
    </div>
  );
}

export function AdminPageCardMeta({ children, className = "" }) {
  return (
    <div
      className={`flex flex-wrap items-center justify-between gap-2 border-b border-gray-100 bg-white px-4 py-3 sm:px-5 ${className}`}
    >
      {children}
    </div>
  );
}

export default AdminPageLayout;
